<template>
  <div>
    <div class="grid bg-white">
      <div class="grid-title">
        <h4>Composition Labels</h4>
      </div>
      <div class="grid-body">
        <div class="row">
          <div class="col-md-12 text-right">
            <a
              class="btn shadow btn-primary"
              @click="showCreateModal()"
              v-if="!isReadOnlyUser"
            >
              <i class="fa fa-plus-circle" aria-hidden="true"></i> Create New
              Composition label
            </a>
          </div>
        </div>
        <div class="row mt-20">
          <div class="col-md-12">
            <div class="table-responsive">
              <vue-good-table
                mode="remote"
                :totalRows="totalRecords"
                :pagination-options="{ enabled: true, mode: 'pages' }"
                styleClass="table table-striped"
                :rows="rows"
                :columns="columns"
              >
                <template slot="table-row" slot-scope="props">
                  <span v-if="props.column.field === 'fiber_1'">
                    {{ props.row.fiber_1 }}
                    <i
                      v-if="
                        props.row.fiber_1_percentage !== null &&
                        props.row.fiber_1_percentage > 0
                      "
                    >
                      | {{ props.row.fiber_1_percentage }} %
                    </i>
                  </span>
                  <span v-else-if="props.column.field === 'fiber_2'">
                    {{ props.row.fiber_2 }}
                    <i
                      v-if="
                        props.row.fiber_2_percentage !== null &&
                        props.row.fiber_2_percentage > 0
                      "
                    >
                      | {{ props.row.fiber_2_percentage }} %
                    </i>
                  </span>
                  <span v-else-if="props.column.field === 'fiber_3'">
                    {{ props.row.fiber_3 }}
                    <i
                      v-if="
                        props.row.fiber_3_percentage !== null &&
                        props.row.fiber_3_percentage > 0
                      "
                    >
                      | {{ props.row.fiber_3_percentage }} %
                    </i>
                  </span>
                  <span v-else>
                    {{ props.formattedRow[props.column.field] }}
                  </span>

                  <span v-if="props.column.field == 'action_id'">
                    <div class="dropdown" v-if="!isReadOnlyUser">
                      <button
                        class="btn btn-default dropdown-toggle"
                        data-toggle="dropdown"
                      >
                        <span class="caret"></span>
                      </button>
                      <ul class="dropdown-menu dropdown-menu-right">
                        <li>
                          <a
                            class="pointer"
                            @click="showUpdateModal(props.row.originalIndex)"
                            >Update</a
                          >
                        </li>
                        <li>
                          <a
                            class="pointer"
                            @click="
                              deleteCompositionLabel(props.row.originalIndex)
                            "
                            >Delete</a
                          >
                        </li>
                      </ul>
                    </div>
                  </span>
                </template>
              </vue-good-table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div
      class="modal fade"
      id="modal-box"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modelTitleId"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title text-bold" v-if="editId != null">
              Update Composition Label
            </h5>
            <h5 class="modal-title text-bold" v-else>New Composition Label</h5>
          </div>
          <div class="modal-body bg-white">
            <div class="form-group row">
              <label class="col-sm-3 col-form-label">Name</label>
              <div class="col-sm-6">
                <input
                  type="text"
                  name="label_name"
                  class="form-control"
                  v-model="formData.label_name"
                  placeholder="Name"
                />
                <small v-if="errors.label_name" class="form-text text-danger">{{
                  errors.label_name.join(" ")
                }}</small>
              </div>
            </div>

            <div class="form-group row">
              <label class="col-sm-3 col-form-label">Fiber 1</label>
              <div class="col-sm-6">
                <v-select
                  :options="fieldValues.fibers"
                  v-model="formData.fiber_1"
                  @input="checkIfResetPercentageRequired(1)"
                  placeholder="Choose One"
                />
                <small v-if="errors.fiber_1" class="form-text text-danger">{{
                  errors.fiber_1.join(" ")
                }}</small>
              </div>
              <div class="col-md-3">
                <input
                  type="number"
                  class="form-control slider-value"
                  v-model="formData.fiber_1_percentage"
                />
                <small
                  v-if="errors.fiber_1_percentage"
                  class="form-text text-danger"
                  >{{ errors.fiber_1_percentage.join(" ") }}</small
                >
              </div>
            </div>

            <div class="form-group row">
              <label class="col-sm-3 col-form-label">Fiber 2</label>
              <div class="col-sm-6">
                <v-select
                  :options="fieldValues.fibers"
                  v-model="formData.fiber_2"
                  @input="checkIfResetPercentageRequired(2)"
                  placeholder="Choose One"
                />
                <small v-if="errors.fiber_2" class="form-text text-danger">{{
                  errors.fiber_2.join(" ")
                }}</small>
              </div>
              <div class="col-md-3">
                <input
                  type="number"
                  class="form-control slider-value"
                  v-model="formData.fiber_2_percentage"
                />
                <small
                  v-if="errors.fiber_2_percentage"
                  class="form-text text-danger"
                  >{{ errors.fiber_2_percentage.join(" ") }}</small
                >
              </div>
            </div>

            <div class="form-group row">
              <label class="col-sm-3 col-form-label">Fiber 3</label>
              <div class="col-sm-6">
                <v-select
                  :options="fieldValues.fibers"
                  v-model="formData.fiber_3"
                  @input="checkIfResetPercentageRequired(3)"
                  placeholder="Choose One"
                />
                <small v-if="errors.fiber_3" class="form-text text-danger">{{
                  errors.fiber_3.join(" ")
                }}</small>
              </div>
              <div class="col-md-3">
                <input
                  type="number"
                  class="form-control slider-value"
                  v-model="formData.fiber_3_percentage"
                />
                <small
                  v-if="errors.fiber_3_percentage"
                  class="form-text text-danger"
                  >{{ errors.fiber_3_percentage.join(" ") }}</small
                >
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Close
            </button>
            <button
              type="button"
              class="btn btn-primary"
              v-if="editId != null"
              @click="updateCompositionLabel()"
            >
              Update
            </button>
            <button
              type="button"
              class="btn btn-primary"
              v-else
              @click="createCompositionLabel()"
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- modal -->
  </div>
</template>

<script>
import { TableHelper } from "@/pages/Tools/TableHelper.js";
import { VueGoodTable } from "vue-good-table";

export default {
  components: {
    VueGoodTable,
  },
  data() {
    return {
      columns: [
        {
          label: "#ID",
          field: "id",
          tdClass: "text-center",
          thClass: "bg-primary text-center",
        },
        {
          label: "Name",
          field: "label_name",
          tdClass: "",
          thClass: "bg-primary",
        },
        {
          label: "Fiber 1",
          field: "fiber_1",
          tdClass: "",
          thClass: "bg-primary",
        },
        {
          label: "Fiber 2",
          field: "fiber_2",
          tdClass: "",
          thClass: "bg-primary",
        },
        {
          label: "Fiber 3",
          field: "fiber_3",
          tdClass: "",
          thClass: "bg-primary",
        },
        {
          label: "",
          field: "action_id",
          tdClass: "text-center",
          thClass: "bg-primary text-center",
          sortable: false,
        },
      ],
      rows: [],
      formData: {
        label_name: null,
        fiber_1: null,
        fiber_1_percentage: null,
        fiber_2: null,
        fiber_2_percentage: null,
        fiber_3: null,
        fiber_3_percentage: null,
      },
      editId: null,
      sortType: "asc",
      totalRecords: 0,
      errors: {},
      isReadOnlyUser: false,
      fieldValues: {
        fibers: [],
        label: null,
      },
    };
  },
  mounted() {
    this.isReadOnlyUser = this.$auth.user().role === "read_only";
    this.getScreenData();
    this.helper = new TableHelper({
      parent: this,
      endpoint: "/v2/fabrics/compositions",
      sort: {
        label_name: "asc",
      },
    });
  },
  methods: {
    resetFormData() {
      this.formData = {
        label_name: null,
        fiber_1: null,
        fiber_1_percentage: null,
        fiber_2: null,
        fiber_2_percentage: null,
        fiber_3: null,
        fiber_3_percentage: null,
      };
    },
    async getScreenData() {
      let response = await axios({
        method: "get",
        url: "v2/fabrics/compositions/create",
      });
      if (response.data.status === "OK") {
        this.fieldValues = response.data.data;
      }
    },
    async createCompositionLabel() {
      try {
        let response = await axios.post(
          "v2/fabrics/compositions",
          this.formData
        );
        if (response.data.status === "OK") {
          this.resetFormData();
          this.helper.reloadData();
          toastr.success("Success");
          hide_modal("#modal-box");
        }
      } catch (error) {
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        } else {
          this.errors = error.response.data.errors;
          toastr.error("There was some errors, please correct and try again");
        }
      }
    },
    async updateCompositionLabel() {
      try {
        let response = await axios.put(
          `v2/fabrics/compositions/${this.editId}`,
          this.formData
        );
        if (response.data.status === "OK") {
          this.resetFormData();
          this.helper.reloadData();
          toastr.success("Success");
          hide_modal("#modal-box");
        }
      } catch (error) {
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        } else {
          this.errors = error.response.data.errors;
          toastr.error("There was some errors, please correct and try again");
        }
      }
    },
    showCreateModal() {
      this.editId = null;
      this.resetFormData();
      this.errors = {};
      show_modal("#modal-box");
    },
    showUpdateModal(index) {
      this.editId = this.rows[index].id;
      const data = this.rows[index];
      this.errors = {};
      this.formData = {
        label_name: data.label_name,
        fiber_1: data.fiber_1,
        fiber_1_percentage: data.fiber_1_percentage,
        fiber_2: data.fiber_2,
        fiber_2_percentage: data.fiber_2_percentage,
        fiber_3: data.fiber_3,
        fiber_3_percentage: data.fiber_3_percentage,
      };
      show_modal("#modal-box");
    },
    async deleteCompositionLabel(index) {
      let result = await Swal.fire({
        title: "Are you sure to Delete?",
        type: "warning",
        showCancelButton: true,
        cancelButtonText: "NO",
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "DELETE",
      });

      if (!result.value) {
        return;
      }
      try {
        let data = this.rows[index];
        let response = await axios.delete(`v2/fabrics/compositions/${data.id}`);
        if (response.data.status === "OK") {
          this.helper.reloadData();
          toastr.success("SUCCESS");
        }
      } catch (error) {
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        } else {
          toastr.error(
            `Unable to delete this composition label. ${error.response.data.message}. Contact the admins for help!`
          );
        }
      }
    },
    checkIfResetPercentageRequired(fiber) {
      if (this.formData["fiber_" + fiber] == null) {
        this.formData["fiber_' + fiber + '_percentage"] = null;
      }
    },
  },
};
</script>
